module.exports = __webpack_public_path__ + "img/6_16.7df8fbee.png";